import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { WorkAuthorView } from "./WorkAuthorView";
import { WorkAuthorViewStore } from "../../store/WorkAuthorViewStore";
import { useStore } from "../../../../hooks";

export const WorkAuthorViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/workAuthor/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new WorkAuthorViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <WorkAuthorView workAuthorViewStore={store} />
      </PageLayout>
    </div>
  );
});
